
import { Component, Vue } from "vue-property-decorator";
import { actions } from "@/survey";
import InputWithLabel from "@/components/InputWithLabel.vue";
import { ColorPicker, ColorPanel } from "one-colorpicker";
import { required } from "vuelidate/lib/validators";
import { sanitizeSvg } from "@/sanitizeSvg";
import {
  EquipmentIconCategory,
  equipmentIconLibrary,
  guessEquipmentIconKey,
  renderEquipmentIconSvg
} from "@/equipmentIconLibrary";

@Component({
  validations: {
    equipmentType: {
      name: { required },
      iconSvg: { required }
    }
  },
  components: { InputWithLabel, ColorPanel }
})
export default class AdminEquipmentTypeForm extends Vue {
  selectedIconKey = "other";

  mounted() {
    this.selectedIconKey = guessEquipmentIconKey(this.$data.equipmentType.name);
    if (this.$data.equipmentType.iconSvg.length === 0) {
      this.chooseLibraryIcon(this.selectedIconKey);
    }
  }

  get sanitizedIcon() {
    return sanitizeSvg(this.$data.equipmentType.iconSvg);
  }

  get iconCategories(): EquipmentIconCategory[] {
    return ["Security", "Fire", "Building", "Network", "General"];
  }

  iconsByCategory(category: EquipmentIconCategory) {
    return equipmentIconLibrary.filter(icon => icon.category === category);
  }

  renderIcon(key: string) {
    return renderEquipmentIconSvg(key, this.$data.equipmentType.color || "#ff1f1f");
  }

  chooseLibraryIcon(key: string) {
    this.selectedIconKey = key;
    this.$data.equipmentType.iconSvg = renderEquipmentIconSvg(
      key,
      this.$data.equipmentType.color || "#ff1f1f"
    );
  }

  data() {
    try {
      const etId = parseInt(this.$route.params.id);
      for (const et of this.$store.state.equipmentTypes) {
        if (et.id === etId) {
          return {
            equipmentType: { ...et }
          };
        }
      }
      throw "Cannot find equipment type for id " + etId;
    } catch (e) {
      return {
        equipmentType: {
          id: null,
          name: "",
          color: "#ff1f1f",
          iconSvg: ""
        }
      };
    }
  }

  onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      alert("Cannot save record, see form for error messages");
      return;
    }
    this.$store.dispatch(actions.CREATE_OR_UPDATE_EQUIPMENT_TYPE, {
      toSave: this.$data.equipmentType,
      success: () => this.$router.push("/admin/equipment-types")
    });
  }

  readURL() {
    const input = this.$refs.fileInput as HTMLInputElement;
    if (input.files && input.files[0]) {
      const type = input.files[0].type;
      if (type !== "image/svg+xml") {
        alert("Icon file must be an SVG image");
        input.value = "";
        return;
      }
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (e.target !== null) {
          const svg = atob(`${e.target.result!!}`.split(",")[1]);
          const sanitizedSvg = sanitizeSvg(svg);
          if (sanitizedSvg.length === 0) {
            alert("Icon file is not a valid SVG image");
            input.value = "";
            return;
          }
          this.$data.equipmentType.iconSvg = sanitizedSvg;
          this.selectedIconKey = "";
        }
      };
      reader.readAsDataURL(input.files[0]);
    }
  }
}
